import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../api';

const Ctx = createContext(null);

export function AppProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('pp_token') || null);
  const [user, setUser] = useState(null);
  const [cats, setCats] = useState([]);
  const [selectedCatId, setSelectedCatId] = useState(() => localStorage.getItem('pp_cat') || null);
  const [loading, setLoading] = useState(true);

  const chooseCat = (id) => { if (id) localStorage.setItem('pp_cat', id); setSelectedCatId(id); };

  const saveToken = (t) => {
    if (t) localStorage.setItem('pp_token', t);
    else localStorage.removeItem('pp_token');
    setToken(t);
  };

  useEffect(() => {
    let active = true;
    (async () => {
      if (!token) { setLoading(false); return; }
      try {
        const [meRes, catsRes] = await Promise.all([api.get('/auth/me'), api.get('/cats')]);
        if (!active) return;
        setUser(meRes.data.user);
        setCats(catsRes.data.cats);
      } catch (e) {
        if (!active) return;
        saveToken(null); setUser(null); setCats([]);
      }
      if (active) setLoading(false);
    })();
    return () => { active = false; };
  }, [token]);

  const login = async (email, password) => {
    const r = await api.post('/auth/login', { email, password });
    saveToken(r.data.token); setUser(r.data.user);
    const c = await api.get('/cats'); setCats(c.data.cats);
    return { user: r.data.user, cats: c.data.cats };
  };
  const register = async (email, name, password, acceptedTerms, code) => {
    const r = await api.post('/auth/register', { email, name, password, accepted_terms: !!acceptedTerms, code: code || '' });
    saveToken(r.data.token); setUser(r.data.user); setCats([]);
    return { user: r.data.user, cats: [], perk: r.data.perk };
  };
  const logout = () => { saveToken(null); setUser(null); setCats([]); };
  const deleteAccount = async () => {
    try { await api.delete('/auth/me'); } catch (e) {}
    saveToken(null); setUser(null); setCats([]);
  };
  const addCat = async (cat) => {
    const r = await api.post('/cats', cat);
    setCats((p) => [...p, r.data.cat]);
    chooseCat(r.data.cat.id);
    return r.data.cat;
  };
  const removeCat = async (id) => {
    await api.delete(`/cats/${id}`);
    setCats((p) => {
      const next = p.filter((c) => c.id !== id);
      if (selectedCatId === id) chooseCat(next[0]?.id || null);
      return next;
    });
  };
  const updateCat = async (id, patch) => {
    const r = await api.put(`/cats/${id}`, patch);
    setCats((p) => p.map((c) => (c.id === id ? r.data.cat : c)));
    return r.data.cat;
  };
  const updateProfile = async (patch) => {
    const r = await api.patch('/auth/profile', patch);
    setUser(r.data.user);
    return r.data.user;
  };
  const updateNotifPrefs = async (prefs) => {
    const r = await api.patch('/notifications/prefs', prefs);
    setUser((u) => ({ ...u, notif_prefs: r.data.notif_prefs }));
    return r.data.notif_prefs;
  };
  const setPro = (plan) => setUser((u) => ({ ...u, is_pro: true, plan }));
  const refreshUser = async () => {
    try { const r = await api.get('/auth/me'); setUser(r.data.user); return r.data.user; } catch (e) { return null; }
  };

  const selectedCat = cats.find((c) => c.id === selectedCatId) || cats[0] || null;

  return (
    <Ctx.Provider value={{ token, user, cats, selectedCat, selectedCatId, chooseCat, loading, login, register, logout, deleteAccount, addCat, removeCat, updateCat, updateProfile, updateNotifPrefs, setPro, setUser, refreshUser }}>
      {children}
    </Ctx.Provider>
  );
}

export const useApp = () => useContext(Ctx);
